<template>
  <div>
    <el-dialog class="wp80 hp80" v-model="openList" :close-on-click-modal="false" :show-close="false" destroy-on-close>
      <template #header>
        <div class="header-left">
          <el-icon class="header-icon">
            <Edit />
          </el-icon>
          <span class="header-title">用印</span>
        </div>
        <div class="header-right">
          <el-button type="info" text @click="openList=false;homeCloseWindow('openReturn', emits, false)">
            <el-icon>
              <Close />
            </el-icon>
          </el-button>
        </div>
      </template>
      <div class="list-page pl0 pr0 pt0 pb0">
        <el-container>
          <el-header>
            <!-- 搜索区域 BEGIN -->
            <el-form class="search-box" :model="dataGrid.parms" @submit.enter.prevent>
              <el-form-item>
                <el-select placeholder="公章" v-model="dataGrid.parms.gzid" clearable filterable @change="bindTable()">
                  <el-option v-for="item in gzData" :key="item.id" :label="item.zzmc" :value="item.id" />
                </el-select>
              </el-form-item>
              <el-form-item>
                <el-input placeholder="申请人" v-model="dataGrid.parms.sqrxm" clearable @clear="bindTable()" @keyup.enter="bindTable()">
                  <template #suffix>
                    <el-icon class="el-input__icon pointer" @click="bindTable()">
                      <search />
                    </el-icon>
                  </template>
                </el-input>
              </el-form-item>
              <el-form-item>
                <el-input placeholder="用印登记号" v-model="dataGrid.parms.yydjh" clearable @clear="bindTable()" @keyup.enter="bindTable()">
                  <template #suffix>
                    <el-icon class="el-input__icon pointer" @click="bindTable()">
                      <search />
                    </el-icon>
                  </template>
                </el-input>
              </el-form-item>
            </el-form>
            <!-- 搜索区域 END -->
            <!-- 按钮区域 BEGIN -->
            <div class="button-box">
              <el-button type="primary" @click="openAdd=true"><span class="iconfont icon-chuangjian"></span>添加</el-button>
            </div>
            <!-- 按钮区域 END -->
          </el-header>
          <el-main>
            <el-table :data="dataGrid.data" :default-sort="dataGrid.orderBy" v-loading="dataGrid.loading" @sort-change="dataGrid.sortChange" @selection-change="dataGrid.selectionChange" height="100%" border stripe>
              <!-- 冻结列-Left BEGIN -->
              <el-table-column label="序号" type="index" width="80" fixed align="center" />
              <!-- 冻结列-Left END -->
              <el-table-column label="用印登记号" prop="yydjh" align="center" show-overflow-tooltip sortable :sort-orders="['ascending', 'descending']" />
              <el-table-column label="申请人" prop="sqrxm" align="center" show-overflow-tooltip sortable :sort-orders="['ascending', 'descending']" />
              <el-table-column label="公章" prop="gzmc" align="center" show-overflow-tooltip sortable :sort-orders="['ascending', 'descending']" />
              <el-table-column label="用印事由" prop="yysy" align="center" show-overflow-tooltip sortable :sort-orders="['ascending', 'descending']" />
              <el-table-column label="事由关联号" prop="syglh" align="center" show-overflow-tooltip sortable :sort-orders="['ascending', 'descending']" />
              <el-table-column label="用印次数" prop="yycs" align="center" show-overflow-tooltip sortable :sort-orders="['ascending', 'descending']" />
              <el-table-column label="用印批准人" prop="yrpzrxm" align="center" show-overflow-tooltip sortable :sort-orders="['ascending', 'descending']" />
              <el-table-column label="状态" prop="" align="center" show-overflow-tooltip sortable :sort-orders="['ascending', 'descending']">
                <template #default="scope">
                  <span v-if="scope.row.zt == 0">未提交</span>
                  <span v-if="scope.row.zt == 1">审批中</span>
                  <span v-if="scope.row.zt == 9">通过</span>
                  <span v-if="scope.row.zt == 10">拒绝</span>
                </template>
              </el-table-column>
              <!-- 冻结列-Right BEGIN -->
              <el-table-column label="操作" width="200" fixed="right" align="center">
                <template #default="scope">
                  <el-button link type="primary" v-if="scope.row.zt == 0 || scope.row.zt == 10" @click="tiJiaoClick(scope.row)">提交</el-button>
                  <el-button link type="success" @click="openDetail=true; row=scope.row">详情</el-button>
                  <el-button link type="primary" v-if="scope.row.zt == 0 || scope.row.zt == 10" @click="openEdit=true; row=scope.row">修改</el-button>
                  <el-button link type="warning" v-if="scope.row.zt == 0 || scope.row.zt == 10" @click="dataGrid.multipleSelection=[scope.row.id]; remove()">删除</el-button>
                </template>
              </el-table-column>
              <!-- 冻结列-Right END -->
            </el-table>
          </el-main>
          <el-footer>
            <pagination :pagination="dataGrid.pagination" @ReturnData="bindTable" />
          </el-footer>
        </el-container>
      </div>
    </el-dialog>
  </div>
  <add v-if="openAdd" v-model:openAdd="openAdd" @ReturnData="bindTable" />
  <edit v-if="openEdit" v-model:openEdit="openEdit" :row="row" @ReturnData="bindTable" />
  <detail v-if="openDetail" v-model:openDetail="openDetail" :row="row" />
</template>

<script setup>
import { ref, watch, defineProps, defineEmits, unref } from 'vue'

import {
  loadList,
  submitDataGridAction,
  loadSelect,
  actionPost,
  homeCloseWindow
} from '@/api/common.js'
import { successPrompt, warningPrompt } from '@/utils/promptInfo.js'
import pagination from '@/components/pagination.vue'
import add from './add.vue'
import edit from './edit.vue'
import detail from './detail.vue'

const props = defineProps({ open: { type: String, required: true }, row: { type: Object, required: false } })
const emits = defineEmits(['openReturn', 'ReturnData'])

const gzData = ref([])
const dataGrid = ref({
  parms: {},
  data: [],
  pagination: {},
  loading: false,
  orderBy: { prop: 'gzid', order: 'ascending' },
  multipleSelection: [],
  sortChange: function (column) {
    dataGrid.value.orderBy.prop = column.prop
    dataGrid.value.orderBy.order = column.order
    bindTable()
  },
  selectionChange: function (selection) {
    dataGrid.value.multipleSelection = selection.map((item) => item.id)
  }
})
const bindTable = async (pageNo, pageSize) => {
  loadList({
    url: '/api/v2/bangong/bangongyonyinguanli/pagelist',
    pageNo: pageNo || 1,
    pageSize: pageSize || 100,
    dataGrid: dataGrid.value,
    loadSuccess: function () {
      dataGrid.value.multipleSelection = []
    }
  })
}
bindTable()

// 提交
const tiJiaoClick = (row) => {
  const o = {
    url: '/api/v2/bangong/bangongyonyinguanli/tijiao',
    data: {
      id: row.id,
      yydjh: row.yydjh,
      gzid: row.gzid,
      yysy: row.yysy,
      syglh: row.syglh,
      yycs: row.yycs,
      yyrq: row.yyrq,
      zsrid: row.zsrid
    }
  }
  actionPost(o).then((res) => {
    if (res.code === 200) {
      successPrompt(res.message)
      bindTable()
    } else {
      warningPrompt(res.message)
    }
  })
}

// 弹窗
const row = ref()
const openAdd = ref(false)
const openEdit = ref(false)
const openDetail = ref(false)
const openList = ref(false)

// 删除
const remove = async () => {
  submitDataGridAction({
    url: '/api/v2/bangong/bangongyonyinguanli',
    dataGrid: dataGrid.value,
    confirmTitle: '确定要删除吗?',
    method: 'delete',
    callback: function () {
      bindTable()
    }
  })
}

watch(
  () => props.open,
  () => {
    if (props.open === 'yongyinshenqing') {
      openList.value = true
      loadSelect({
        url: '/api/v2/bangong/bangongzhizhangguanli/list',
        data: gzData,
        order: 'gzbh',
        sort: 'asc'
      })
      bindTable()
    } else {
      openList.value = false
    }
  },
  { deep: true, immediate: true }
)
</script>
